{
  "digital_twin_network": {
    "title": "No se pudo conectar al Digital Twin",
    "subtitle": "Vamos a hacer algunas comprobaciones para ver qué salió mal...",
    "title_success": "La prueba de conexión se realizó correctamente",
    "subtitle_success": "Para conectarse al Digital Twin, regrese al mapa y haga clic en el botón Digital Twin",
    "support_1": " Por favor, revise el ",
    "documentation": "Documentación",
    "support_2": " para la configuración del firewall y la conexión. Si el problema persiste, ponte en contacto con el servicio de asistencia en",
    "iventis_card": {
      "title": "Iventis",
      "subtitle": "Principales servicios de aplicaciones"
    },
    "websocket_card": {
      "title": "Websocket",
      "subtitle": "Establezca la conexión Digital Twin"
    },
    "webRTC_card": {
      "title": "WebRTC",
      "subtitle": "Comunicación por vídeo y en tiempo real con el Digital Twin"
    },
    "return_to_map": "Volver al mapa",
    "recommended_actions": {
      "title": "Acción sugerida",
      "iventis": "Comprueba tu conexión a Internet e inténtalo de nuevo. Si el problema persiste, ponte en contacto con el servicio de asistencia en",
      "websocket": "Compruebe la configuración de su red y firewall para asegurarse de que las conexiones a Websocket están permitidas y de que no hay reglas de firewall que bloqueen la conexión a iventis.com. Si el problema persiste, póngase en contacto con el servicio de asistencia en",
      "webRTC": "Compruebe la configuración de su red y firewall para asegurarse de que las conexiones WebRTC están permitidas y de que los puertos 19302, 19303 y 10000-65535 están abiertos y permiten las solicitudes STUN y TURN a iventis.com. Si el problema persiste, póngase en contacto con el servicio de asistencia en"
    },
    "testing": "Probando la conexión, espere..."
  },
  "model_preview": {
    "toggle_bounding_box": "Activa o desactiva el cuadro delimitador",
    "bounding_box_check": "Compruebe que el modelo se ajusta al cuadro delimitador",
    "bounding_box_check_dimensions": "Compruebe que el modelo se ajusta al cuadro delimitador y que las dimensiones son correctas",
    "dimensions_warning": "La edición de las dimensiones no cambia el tamaño del modelo. Estos valores se utilizan como dimensiones de referencia al aplicar tamaños personalizados en los estilos de capa",
    "length_axis_colour": "Eje rojo",
    "width_axis_colour": "Eje verde",
    "height_axis_colour": "Eje azul",
    "advanced_options": "Avanzado"
  },
  "data_table_filter": {
    "operator": "Operador"
  },
  "map_settings": {
    "interface_style": "Estilo de interfaz de mapa",
    "compressed": "Comprimido",
    "spacious": "Espacioso"
  }
}